import backend, {AGENTCORE_ENGINE_API} from 'utils/backend/server/api_library';

const listDomainGuides = () => {
  const url = `${AGENTCORE_ENGINE_API}/domain_guide`;
  return backend.get(url);
};

const getDomainGuide = (domainGuideRn) => {
  const url = `${AGENTCORE_ENGINE_API}/domain_guide/${domainGuideRn}`;
  return backend.get(url);
};

const updateStatus = (domainGuideRn, status) => {
  const url = `${AGENTCORE_ENGINE_API}/domain_guide/${domainGuideRn}/status`;
  const body = {
    status,
  };
  return backend.put(url, body);
};

export default {
  getDomainGuide,
  listDomainGuides,
  updateStatus,
};
